import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { modificationState } from "../handlers/modifications";
import { updateState, pipeline } from "../handlers/updates";
import { selectionState } from "../handlers/selection"
import Alpine from "alpinejs";
import tippy, { Instance } from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";

export default class OfficeStateIndicator extends AlpineComponent {
  private tippy!: Instance;

  constructor(
  ) {
    super();
  }

  init() {
    this.tippy = tippy(this.$el, {
      content: this.tooltip(),
      theme: "light",
      allowHTML: true,
    });

    Alpine.effect(() => {
      this.tippy.setContent(this.tooltip());
      this.style();
      this.text();
    });
  }

  tooltip(): string {
    return this.friendlyTooltip();
  }

  technicalTooltip(): string {
    return `Modification: ${modificationState.phase}<br>Update: ${updateState.phase}<br>Selection: ${selectionState.value}`;
  }

  friendlyTooltip(): string {
    if (modificationState.phase === "unregistered") {
      return "Document not tracked";
    }

    if (updateState.phase === "error") {
      return "Sync error — click to retry";
    }

    if (updateState.phase === "stopped") {
      return "Sync stopped — click to retry";
    }

    if (updateState.phase === "uploading") {
      return "Saving changes…";
    }

    if (updateState.phase === "downloading") {
      return "Loading updates…";
    }

    if (updateState.phase === "debouncing") {
      return "Changes pending…";
    }

    if (this.isSmartCursorOn()) {
      return "Up to date — Smart Cursor on";
    }

    return "Up to date";
  }

  private isSmartCursorOn(): boolean {
    return selectionState.value === "idle" || selectionState.value === "debouncing" || selectionState.value === "querying";
  }

  style(): string {
    if (modificationState.phase === "unregistered") {
      return this.color("#9e9e9e");
    }

    if (updateState.phase === "error" || updateState.phase === "stopped") {
      return this.color("#b10e1c");
    }

    if (updateState.phase === "idle") {
      return this.color("#0e7a0b");
    }

    if (updateState.phase === "debouncing") {
      return this.color("#ffc400");
    }

    if (updateState.phase === "downloading") {
      return this.color("#4899d7");
    }

    if (updateState.phase === "uploading") {
      return this.color("#4880d7");
    }

    return this.color("#9e9e9e");
  }

  color(value: string): string {
    return `color: ${value};`;
  }

  text(): string {
    if (selectionState.value === "idle" || selectionState.value === "debouncing" || selectionState.value === "querying") {
      return "☉";
    }

    return "●";
  }

  onClick() {
    return pipeline.update()
  }
}
